<template>
    <div>
        <vx-card title="" no-shadow card-border id="" class="mt-base">
            <div class="flex items-end">
                <feather-icon icon="FileIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">Reporte del Registro</span>
            </div>

            <vs-divider/>

            <div class="flex flex-wrap-reverse justify-between">
                <div class="w-full vx-col md:w-1/2">
                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2">
                            <span class="flex flex-wrap-reverse justify-end"><strong>Titulo del registro: </strong></span>
                        </div>
                        <div class="w-full vx-col md:w-1/2">
                            <span class=""> {{ itemsRegistro !== null ? itemsRegistro.title : '' }}</span>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2">
                            <span class="flex flex-wrap-reverse justify-end"><strong>Descripcion del registro: </strong></span>
                        </div>
                        <div class="w-full vx-col md:w-1/2">
                            <span class=""> {{ itemsRegistro !== null ? itemsRegistro.description : '' }}</span>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2">
                            <span class="flex flex-wrap-reverse justify-end"><strong>Fecha de Registro: </strong></span>
                        </div>
                        <div class="w-full vx-col md:w-1/2">
                            <span class="">{{ itemsRegistro !== null ? itemsRegistro.fechaRegistro : '' }}</span>
                        </div>
                    </div>

                </div>
                <div class="w-full vx-col md:w-1/2">
                    <div class="vx-row">
                        <div class="w-full vx-col md:w-1/4">
                            <vx-card class="overflow-hidden mb-base" id="grid-view-meta-item" v-if="itemsRegistro !== null">
                                <template slot="no-body">
                                    <div class="flex items-center justify-end h-64 bg-white cursor-pointer item-img-container" @click="showImage(itemsRegistro)">
                                        <img :src="'data:image/jpg;base64,' + itemsRegistro.image" class="px-1 rounded grid-view-img user-latest-image responsive">
                                    </div>
                                </template>
                            </vx-card>
                        </div>
                    </div>

                </div>
            </div>            

            <vx-card class="mb-4" no-shadow>
                <div class="map-holder">
                    <div id="map" class="w-full vx-col"></div>
                </div>
            </vx-card>

            <div class="w-full vx-col">
                <div class="flex flex-wrap items-center justify-start">
                    <vs-button @click="regresar" icon-pack="feather" color="danger" icon="icon-rotate-ccw" class="mt-2 ml-auto">Regresar</vs-button>
                </div>
            </div>
        </vx-card>

        <vs-popup title="Imagen Registrado" :active.sync="popupImagen" id="id-popup-actividad-list">
            <div class="profile-header">
                <div class="relative">
                    <div class="rounded-t-lg cover-container">
                        <img :src="'data:image/jpg;base64,' + imageActividad" alt="user-profile-cover" class="block rounded responsive">
                    </div>
                </div>
            </div>
        </vs-popup>
        
    </div>
</template>
<script>
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
const VUE_APP_MAP_ACCESS_TOKEN='pk.eyJ1IjoiY29uc2FjaGFwaSIsImEiOiJjbGh6ZWxscG4wMnVsM3NteHFhYXM0YTBqIn0.d_FvFlICiWjVzsOwR7RJTQ';

import iconType1 from '@/assets/images/person/icon-marker.png';
import iconType2 from '@/assets/images/person/icon-person.png';

export default {
    components: {
        mapboxgl
    },

    data(){
        return {
            parametro       : null,
            residente       : null,
            meta            : null,

            itemsRegistro   : null,
            proyecto        : null,
            imageActividad  : null,
            imageLatitud    : null,
            imageLongitud   : null,
            popupImagen     : false,

            location        : "",
            access_token    : VUE_APP_MAP_ACCESS_TOKEN,
            center          : [-71.9634369, -13.5243935],
            map             : {},
        }
    },

    created(){
        this.parametro = this.$route.params.id;
    },

    mounted(){
        this.fetchById(this.parametro);
    },

    methods: {
        showImage(value){
            this.imageActividad = value.image;
            this.popupImagen = true;
        },

        fetchById(id){
            this.$vs.loading();
            this.$http.fetchActivityById(id)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsRegistro = response.data;
                    console.log(this.itemsRegistro);
                    this.getFeatures(response.data);
                }
            }).catch(error => {
                this.$vs.loading.close();
                console.log("error: ", error);
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getFeatures(itemsRegistro){
            let features = [];
            let isProject = true;
            
            if(isProject){
                const ssi =  `https://ofi5.mef.gob.pe/repseguim/proyinv09.html?codigo=${ itemsRegistro.ubicacion.cui }`;
                const desc = `<strong><a href="${ ssi }" target="_blank" title="Ver en SSI">CUI: ${ itemsRegistro.ubicacion.cui }</a><br></strong><strong>Nombre de Inversión: </><p>${ itemsRegistro.ubicacion.nombre }</p>`;
                if(itemsRegistro.ubicacion.x !== null && itemsRegistro.ubicacion.y !== null){
                    const feature = {
                        'type': 'Feature',
                        'properties': {
                            'description': desc,
                            'icon': 'theatre',
                            "color": "#0746b9",
                            'tipo': 'A'
                        },
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [parseFloat(itemsRegistro.ubicacion.x), parseFloat(itemsRegistro.ubicacion.y)],
                        }
                    };
                    features.push(feature);
                }
                isProject = false;
            }
            const latid = itemsRegistro.latitud;
            const longi = itemsRegistro.longitud;
            const detall = `
            <strong class="font-bold text-danger">${ itemsRegistro.title }</strong>
            <br>
            <strong class="text-danger"><small class="font-bold text-primary">${ itemsRegistro.fechaRegistro }<small></strong>
            <div class="rounded-t-lg cover-container" >
                <img src="data:image/jpg;base64,${ itemsRegistro.image }" alt="user-profile-cover" class="block rounded responsive">
            </div>
            `;
            if(latid !== null && longi !== null){
                const feature = {
                    'type': 'Feature',
                    'properties': {
                        'description': detall,
                        'icon': 'theatre',
                        "color": "#C00000",
                        'tipo': 'B'
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [parseFloat(longi), parseFloat(latid)],
                    }
                };
                features.push(feature);
            }
            this.createMap(features);
        },

        async createMap(values) {
            try {
                mapboxgl.accessToken = this.access_token;
                this.map = new mapboxgl.Map({
                    container: "map",
                    style: "mapbox://styles/mapbox/streets-v11",
                    center: this.center,
                    zoom: 7.6,
                });

                this.map.on('load', async () => {
                    const loadImagePromise = (name, path) => {
                        return new Promise((resolve, reject) => {
                            let imageUrl = path;
                            if (!path.startsWith('data:image/')) {
                                imageUrl = require(path);
                                if (imageUrl.default) imageUrl = imageUrl.default;
                            }

                            this.map.loadImage(imageUrl, (error, image) => {
                                if (error) return reject(error);
                                if (!this.map.hasImage(name)) this.map.addImage(name, image);
                                resolve();
                            });
                        });
                    };

                    await Promise.all([
                        loadImagePromise('icon-type1', iconType1),
                        loadImagePromise('icon-type2', iconType2)
                    ]);

                    this.map.addSource("places", {
                        "type": "geojson",
                        "data": {
                            'type': 'FeatureCollection',
                            'features': values
                        }
                    });

                    this.map.addLayer({
                        id: 'places',
                        type: 'symbol',
                        source: 'places',
                        layout: {
                            'icon-image': [
                                'match',
                                ['get', 'tipo'],
                                'A', 'icon-type1',
                                'B', 'icon-type2',
                                'icon-type1'
                            ],
                            'icon-size': 0.8,
                            'icon-anchor': 'bottom',
                            'icon-allow-overlap': true
                        }
                    });

                    this.map.on('click', 'places', (e) => {
                        const coordinates = e.features[0].geometry.coordinates.slice();
                        const description = e.features[0].properties.description;
                        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                        }
                        
                        new mapboxgl.Popup()
                        .setLngLat(coordinates)
                        .setHTML(description)
                        .addTo(this.map);
                    });

                    this.map.on('mouseenter', 'places', () => {
                        this.map.getCanvas().style.cursor = 'pointer';
                    });
                    
                    this.map.on('mouseleave', 'places', () => {
                        this.map.getCanvas().style.cursor = '';
                    });
                });

            } catch (err) {
                console.log("map error: ", err);
            }
        },

        regresar(){
            this.$router.push({
				name: 'monitoreo-diario-meta'
			}).catch(() => {});
        },

        device(value){
            if(value === 1) return 'Web';
            if(value === 2) return 'Android';
            if(value === 3) return 'IPhone';
            if(value === 4) return 'iPod';
            if(value === 5) return 'iPad';
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    },


}
</script>
<style lang="scss">
#map {
  height: 100vh;
  width: 100vh;
}

.mapboxgl-popup {
    max-width: 600px;
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
}

#id-popup-actividad-list {
    .vs-popup {
        width: 980px;
    }
    .vs-con-table {
        .vs-table--thead {
            th {
                background: #d9d8d8;
            }
        }
    }
}

#grid-view-meta-item {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>